import * as React from 'react';
import { cn } from '@/lib/utils';

interface Props {
  /** Anchor id — lets callers deep-link to a card (e.g. #release-0.9.0). */
  id?: string;
  title?: React.ReactNode;
  description?: React.ReactNode;
  actions?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
  bodyClassName?: string;
}

export function SectionCard({ id, title, description, actions, children, className, bodyClassName }: Props) {
  return (
    <section
      id={id}
      className={cn(
        'rounded-xl border border-border/70 bg-card shadow-elev-1',
        className,
      )}
    >
      {(title || actions) && (
        <header className="flex items-start justify-between gap-3 border-b border-border/60 px-5 py-4">
          <div className="space-y-0.5">
            {title && <h2 className="text-sm font-semibold tracking-tight text-foreground">{title}</h2>}
            {description && (
              <p className="text-[12px] text-muted-foreground">{description}</p>
            )}
          </div>
          {actions && <div className="flex shrink-0 items-center gap-2">{actions}</div>}
        </header>
      )}
      <div className={cn('p-5', bodyClassName)}>{children}</div>
    </section>
  );
}
